// extracted by mini-css-extract-plugin
module.exports = {"button":"FormSubmitButton_button__2_9xR"};